import React from 'react'
import Window from './Window'

const Confirm = ({
  title,
  children,
  size = 'md',
  cancelTitle = 'Cancel',
  confirmTitle = 'Confirm',
  onClose,
  onSubmit,
}) => {
  return (
    <Window
      open
      size={ size }
      title={ title }
      withCancel={ onClose ? true : false }
      cancelTitle={ cancelTitle }
      submitTitle={ confirmTitle }
      onCancel={ onClose }
      onSubmit={ onSubmit }
    >
      { children }
    </Window>
  )
}

export default Confirm